var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as queryString from 'query-string';
import { UitkLink } from 'uitk-react-link';
import { ClickTracker } from 'bernie-analytics';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
var AnchorLink = function (props) {
  return React.createElement("a", __assign({}, props));
};
var AnchorLinkTracked = ClickTracker(AnchorLink);
export var HeaderMenuLink = function (props) {
  var item = props.item;
  var action = item.uiAction;
  var linkName = 'Locale';
  var actionProps = (action === null || action === void 0 ? void 0 : action.uiActionType) === 'LOCALE_LINK' ? {
    onClick: function () {
      var queryParams = queryString.parse(window.location.search);
      window.location.search = queryString.stringify(__assign(__assign({}, queryParams), {
        locale: action.locale
      }));
    },
    rfrr: action.referrerId,
    linkName: linkName
  } : {
    href: item.url,
    rfrr: item.trackingEvent,
    target: item.newWindow ? '_blank' : '_self',
    trackImmediate: true,
    linkName: linkName
  };
  return React.createElement(UitkLink, {
    className: "uitk-list-item"
  }, React.createElement(AnchorLinkTracked, __assign({
    "aria-label": item.text
  }, actionProps), item.iconName && React.createElement(UitkSpacing, {
    padding: {
      inlineend: 'three'
    }
  }, React.createElement(UitkIcon, {
    id: "menu-link-".concat(item.iconName),
    name: item.iconName
  })), item.text, item.newWindow && React.createElement("span", {
    className: "screen-reader-select-hidden is-visually-hidden"
  }, item.newWindowAccessibilityText)));
};